import * as actionTypes from "../actions/types.js";
export default (state = { formList: [],myformList:[],submissionformList:[],formLoader:false}, action) => {
    
  switch (action.type) {
    case actionTypes.FORM_LIST:
      return {
        ...state,
        formList: action.payload ? action.payload : [],
      };
    case actionTypes.MYFORM_LIST:
      return {
        ...state,
        myformList: action.payload ? action.payload : [],
      };
    case actionTypes.SUBMISSION_FORM_LIST:
      return {
        ...state,
        submissionformList: action.payload ? action.payload : [],
      };
    case actionTypes.FORM_LOADER:
      return {
        ...state,
        formLoader: action.payload ? action.payload : false,
      };
   
    default:
      return state;
  }
};
